import { atom } from 'jotai'

import type { DataPoint } from '@app/components/Molecules/Charts/ProjectedRiskChart/ProjectedRiskChart'

export interface ProjectedRiskChartState {
  [element: string]: {
    [risk: string]: {
      assetId: string
      yAxisTitle: string
      data: DataPoint[]
      consequenceByReturnPeriod?: {
        primaryParameterKey: string
        parameterUnit: string
        parameterTitle: string
        secondaryParameterKey: string | null
        secondaryParameterValue: number | string | null
        secondaryParameterTitle: string | null
        vulnerabilityList: string[]
        xAxisMode: string
      }
      projectedConsequence?: {
        primaryParameterKey: string
        parameterUnit: string
        parameterTitle: string
        secondaryParameterKey: string | null
        secondaryParameterValue: number | string | null
        secondaryParameterTitle: string | null
        vulnerabilityList: string[]
        projectedConsequenceView: string
      }
    }
  }
}

export const projectedRiskChartStateAtom = atom<ProjectedRiskChartState>({})
